export default __webpack_public_path__ + "static/media/httpswww.twitch.tvvideos2497454551t=2h57m41s.906e1d83.jpg";